import React from 'react';

import Login from '../../components/Auth/LoginComponent';

const Auth = () => {
  return (
    <Login/>
  )
}

export default Auth;
